const ACL = {
  aprovar_arrematante: [
    'geronimo', 8080,
    'igor', 9,
    'michel.tavares', 4622,
    'tiagofelipe', 488,
    'grafael', 1504,
    'luana', 16,
    'rafaelle', 3514,
    'selma', 7797,
    'taiane', 9598,
    'priscila.vargas', 3827,
    'luciana', 1454,
    'henriquegomes', 3584,
    'lucas.mota', 11365,
    'fausto.jesus', 15644,
    'Karine.ferreira', 18309,
    'manoella', 13321,
    'leonardo.nogueira', 4005
  ],
  deletar_lance: [
    'geronimo', 8080,
    'igor', 9,
    'luana', 16,
    'tiagofelipe', 488,
    'luciana', 1454,
    'lucas.mota', 11365
  ],
  visualizar_leilao: [
    'tiago.agente', 10410,
    'taiane', 9598,
    'david.coutinho', 8803,
    'geronimo', 8080,
    'selma', 7797,
    'drfa.rj', 7312,
    'leiloeiro', 5508,
    'michel.tavares', 4622,
    'priscila.vargas', 3827,
    'natalia', 3628,
    'shirlensilva', 3587,
    'henriquegomes', 3584,
    'rafaelle', 3514,
    'barbara', 1580,
    'manoella', 13321,
    'rchianca', 1571,
    'jmiranda', 1569,
    'dccosta', 1566,
    'amacedo', 1565,
    'priscila', 1525,
    'luciana', 1454,
    'mariana', 1453,
    'patricia', 1289,
    'luana', 16,
    'fabio.vinicius', 13175,
    'luciano.viana', 13176,
    'lucas.mota', 11365,
    'grafael', 1504,
    'fnascimento', 1570,
    'tiagofelipe', 488,
    'welton', 4719,
    'igor', 9
  ],
  visualizar_valores_leilao: [
    'igor', 9,
    'tiagofelipe', 488,
    'luciana', 1454,
    'manoella', 13321,
    'barbara', 1580,
    'priscila', 1525,
    'geronimo', 8080,
    'lucas.mota', 11365
  ],
  controlar_leilao: [
    'igor', 9,
    'tiagofelipe', 488,
    'luciana', 1454,
    'lucas.mota', 11365,
    'michel.tavares', 4622
  ],
  deletar_lote_leilao: [
    'igor', 9,
    'geronimo', 8080,
    'luciana', 1454,
    'lucas.mota', 11365,
    'tiagofelipe', 488
  ],
  alterar_status_leilao: [
    'geronimo', 8080,
    'igor', 9,
    'tiagofelipe', 488,
    'selma', 7797,
    'taiane', 9598,
    'luciana', 1454,
    'lucas.mota', 11365
  ],
  alterar_status_lote: [
    'geronimo', 8080,
    'igor', 9,
    'tiagofelipe', 488,
    'selma', 7797,
    'priscila.vargas', 3827,
    'luciana', 1454,
    'manoella', 13321,
    'lucas.mota', 11365
  ],
  adm_alterar_status_lote: [
    'geronimo', 8080,
    'selma', 7797,
    'luciana', 1454,
    'igor', 9,
    'manoella', 13321,
    'lucas.mota', 11365,
    'tiagofelipe', 488
  ],
  gerenciar_usuario_intranet: [
    'igor', 9,
    'tiagofelipe', 488,
    'lucas.mota', 11365,
    'michel.tavares', 4622
  ],
  rh: [
    'igor', 9,
    'tiagofelipe', 488,
    'lucas.mota', 11365
  ],
  alterar_status_grv: [
    'igor', 9,
    'tiagofelipe', 488,
    'geronimo', 8080,
    'selma', 7797,
    'taiane', 9598,
    'luciana', 1454,
    'lucas.mota', 11365
  ],
  alterar_retirada_grv: [
    'igor', 9,
    'lucas.mota', 11365,
    'jaquearedes', 1490,
    'tiagofelipe', 488
  ],
  excluir_usuario_intranet: [
    'igor', 9,
    'tiagofelipe', 488,
    'michel.tavares', 4622,
    'lucas.mota', 11365
  ],
  acesso_menu_relatorios_gerenciais: [
    'igor', 9,
    'priscila', 1525,
    'geronimo', 8080,
    'luciana', 1454,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'lucas.mota', 11365,
    'welton', 4719,
    'priscila.vargas', 3827,
    'barbara', 1580,
    'manoella', 13321,
    'lfaria', 15642,
    'gmendes', 15641,
    'narciso', 10885,
    'jaquearedes', 1490,
    'pmoreira', 15643,
    'edson.bauer', 12959,
    'grafael', 1504,
    'stael', 4284,
    'tiagofelipe', 488,
    'jaquearedes', 1490
  ],
  relatorio_gerenciais_detro: [
    'igor', 9,
    'priscila', 1525,
    'geronimo', 8080,
    'luciana', 1454,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'grafael', 1504,
    'lucas.mota', 11365,
    'welton', 4719,
    'barbara', 1580,
    'jaquearedes', 1490,
    'lfaria', 15642,
    'gmendes', 15641,
    'pmoreira', 15643,
    'stael', 4284,
    'edson.bauer', 12959,
    'tiagofelipe', 488,
    'jaquearedes', 1490
  ],
  relatorio_gerenciais_policia_civil: [
    'igor', 9,
    'priscila', 1525,
    'luciana', 1454,
    'rodolfo', 1926,
    'geronimo', 8080,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'lucas.mota', 11365,
    'barbara', 1580,
    'welton', 4719,
    'jaquearedes', 1490,
    'stael', 4284,
    'lfaria', 15642,
    'gmendes', 15641,
    'pmoreira', 15643,
    'grafael', 1504,
    'tiagofelipe', 488,
    'jaquearedes', 1490
  ],
  relatorio_gerenciais_leilao: [
    'igor', 9,
    'manoella', 13321,
    'barbara', 1580,
    'tiagofelipe', 488,
    'priscila', 1525,
    'luciana', 1454,
    'selma', 7797,
    'david.coutinho', 8803,
    'geronimo', 8080,
    'lucas.mota', 11365,
    'barbara', 1580,
    'lfaria', 15642,
    'gmendes', 15641,
    'pmoreira', 15643,
    'jaquearedes', 1490
  ],
  relatorio_gerenciais_detranES: [
    'igor', 9,
    'manoella', 13321,
    'geronimo', 8080,
    'barbara', 1580,
    'priscila', 1525,
    'priscila.vargas', 3827,
    'stael', 4284,
    'lucas.mota', 11365,
    'barbara', 1580,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'narciso', 10885,
    'tiagofelipe', 488,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'jaquearedes', 1490
  ],
  relatorio_gerenciais_gm_campos_goytacazes: [
    'igor', 9,
    'manoella', 13321,
    'geronimo', 8080,
    'barbara', 1580,
    'priscila', 1525,
    'priscila.vargas', 3827,
    'stael', 4284,
    'lucas.mota', 11365,
    'barbara', 1580,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'narciso', 10885,
    'tiagofelipe', 488,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'jaquearedes', 1490,
    'grafael', 1504
  ],
  relatorio_gerenciais_postura_campos_goytacazes: [
    'igor', 9,
    'manoella', 13321,
    'geronimo', 8080,
    'barbara', 1580,
    'priscila', 1525,
    'priscila.vargas', 3827,
    'stael', 4284,
    'lucas.mota', 11365,
    'barbara', 1580,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'narciso', 10885,
    'tiagofelipe', 488,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'grafael', 1504,
    'jaquearedes', 1490
  ],
  relatorio_gerenciais_imtt_campos_goytacazes: [
    'igor', 9,
    'manoella', 13321,
    'geronimo', 8080,
    'barbara', 1580,
    'priscila', 1525,
    'priscila.vargas', 3827,
    'stael', 4284,
    'lucas.mota', 11365,
    'barbara', 1580,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'narciso', 10885,
    'tiagofelipe', 488,
    'victorlourenco', 3713,
    'grafael', 1504,
    'victor.lourenco', 20686,
    'jaquearedes', 1490
  ],
  temp_alterar_retirada_lote: [
    'igor', 9,
    'tiagofelipe', 488,
    'luciana', 1454,
    'selma', 7797,
    'taiane', 9598,
    'geronimo', 8080,
    'lucas.mota', 11365
  ],
  acesso_menu_localizacao: [
    'lucas.mota', 11365,
    'igor', 9,
    'beneditomartins', 3707,
    'luizcarvalho', 3709,
    'luperceneto', 3710,
    'mariamadureira', 3711,
    'gabrielsilva', 3715,
    'franciscoviegas', 3717,
    'francisco.viegas', 20616,
    'igorlima', 12007,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'fabio.vinicius', 13175,
    'luciano.viana', 13176,
    'wellington.rios', 13306,
    'luizrocha', 7082,
    'bruno.santos', 15145,
    'grafael', 1504,
    'flavio.bezerra', 15146,
    'welton', 4719,
    'tiagofelipe', 488
  ],
  acesso_menu_transferencia: [
    'igor', 9,
    'tiagofelipe', 488,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'jaquearedes', 1490,
    'grafael', 1504,
    'iago.reis', 15776,
    'lucas.mota', 11365,
    'narciso', 10885,
    'celmar', 12806,
    'claudia.nascimento', 12807
  ],
  cadastrar_codigo_sequencial_atendente: [
    'igor', 9,
    'tiagofelipe', 488,
    'lucas.mota', 11365
  ],
  excluir_grv: [
    'delete', 3767,
    'tiagofelipe', 488,
    'igor', 9,
    'michel.tavares', 4622,
    'lucas.mota', 11365
  ],
  corrigir_estadas: [
    'igor', 9,
    'tiagofelipe', 488,
    'lucas.mota', 11365,
    'jaquearedes', 1490,
    'gabrielmiranda', 22799,
    'felipetorres', 22808
  ],
  criar_ggv_policia: [
    'igor', 9,
    'tiagofelipe', 488,
    'carloscarneiro', 3708,
    'edsonsilva', 3716,
    'franciscoviegas', 3717,
    'francisco.viegas', 20616,
    'luizcarvalho', 3709,
    'grafael', 1504,
    'luperceneto', 3710,
    'robertomachado', 3714,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'anagomes', 7081,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'bruno.santos', 15145,
    'luiz.claudio', 20314,
    'mariana', 1453,
    'luciana', 1454,
    'luizrocha', 7082,
    'efigenio', 12805,
    'wendell', 12804,
    'celmar', 12806,
    'jaquearedes', 1490,
    'claudia.nascimento', 12807,
    'fabio.vinicius', 13175,
    'luciano.viana', 13176,
    'mariamadureira', 3711,
    'wellington.rios', 13306,
    'iago.reis', 15776,
    'lucas.mota', 11365,
    'bruno.santos', 15145,
    'luiz.claudio', 20314,
    'antonio.machado', 20464,
    'igorlima', 12007,
    'narciso', 10885
  ],
  visualizar_cevera: [
    'grafael', 1504,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'priscila.vargas', 3827,
    'natalia', 3628,
    'luciano.viana', 13176,
    'igor', 9,
    'tiagofelipe', 488,
    'iago.reis', 15776,
    'geronimo', 8080
  ],
  criar_ggv_detro: [
    'igor', 9,
    'tiagofelipe', 488,
    'carloscarneiro', 3708,
    'edsonsilva', 3716,
    'franciscoviegas', 3717,
    'francisco.viegas', 20616,
    'grafael', 1504,
    'luperceneto', 3710,
    'robertomachado', 3714,
    'geronimo', 8080,
    'viniciuslourenco', 1516,
    'vinicius.lourenco', 20634,
    'bruno.santos', 15145,
    'jaquearedes', 1490,
    'celmar', 12806,
    'Adriana', 1507,
    'wendell', 12804,
    'anagomes', 7081,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'luciana', 1454,
    'luiz.claudio', 20314,
    'camila', 3469,
    'claudia.nascimento', 12807,
    'luizrocha', 7082,
    'fabio.vinicius', 13175,
    'luciano.viana', 13176,
    'wellington.rios', 13306,
    'mariamadureira', 3711,
    'edson.bauer', 12959,
    'iago.reis', 15776,
    'emanuel.souza', 19903,
    'marciosantos', 14474,
    'lucas.mota', 11365,
    'bruno.santos', 15145,
    'luiz.claudio', 20314,
    'antonio.machado', 20464,
    'igorlima', 12007,
    'narciso', 10885
  ],
  restrito_visitante: [
    'drfa.rj', 7312,
    'pvieira', 10850,
    'wrocha', 10849,
    'scosta', 14519,
    'voliveira', 14521,
    'eandrade', 14522,
    'sazavedo', 14523,
    'peterson.santos', 15897,
    'bruno.freitas', 15898,
    'carlos.menezes', 15899,
    'marcelo.abreu', 15900,
    'vinicius.landeira', 15901,
    'helton.tangi', 15902,
    'aldari.pimentel', 15903,
    'claudio.furtado', 17790,
    'detranes.teste', 12387
  ],
  exibir_logs: [
    'tiagofelipe', 488,
    'igor', 9,
    'jaquearedes', 1490,
    'mariana', 1453,
    'michel.tavares', 4622,
    'lucas.mota', 11365
  ],
  exibir_tasks: [
    'tiagofelipe', 488,
    'igor', 9,
    'michel.tavares', 4622,
    'lucas.mota', 11365
  ],
  coordES: [
    'peterson.santos', 15897,
    'bruno.freitas', 15898,
    'carlos.menezes', 15899,
    'marcelo.abreu', 15900,
    'vinicius.landeira', 15901,
    'helton.tangi', 15902,
    'aldari.pimentel', 15903,
    'detranes.teste', 12387
  ],
  visualizar_grv_aberta: [
    'tiagofelipe', 488,
    'igor', 9,
    'flavio.souza', 19184,
    'paulocesar', 1514,
    'debora.santos', 15841,
    'grafael', 1504,
    'victorlourenco', 3713,
    'victor.lourenco', 20686,
    'stael', 4284,
    'fabio.santos', 14557
  ],
  excluir_grv_aberta: [
    'tiagofelipe', 488,
    'igor', 9,
    'grafael', 1504
  ],
  editar_acl_usuario: [
    'tiagofelipe', 488
  ]
}

let storageUser = null

/**
 * @return {boolean}
 */
export const CHECK_ACL = function (acl, user) {
  if (!storageUser) {
    storageUser = JSON.parse(localStorage.getItem('user'))
  }
  user = storageUser
  let ACL = user.acl
  if (!ACL) return false
  ACL = Array.isArray(ACL) ? ACL : Object.values(ACL.acl)
  if (acl === 'restrito_visitante') return !ACL.includes(acl)
  return ACL.includes(acl)

  /* if (typeof ACL[acl] !== 'undefined') {
    if (acl === 'restrito_visitante') {
      return !ACL[acl].includes(user)
    }
    return ACL[acl].includes(user)
  } */
}

export const checaAcessoContrato = function (idContrato, idUser) {
  const user = JSON.parse(localStorage.getItem('user'))
  return user.acessoContratos.indexOf(idContrato) !== -1
}

export default {
  check: CHECK_ACL,
  acl: ACL,
  checaAcessoContrato
}




// WEBPACK FOOTER //
// ./src/domain/acl/tmp-acl.js